export const MinusCircleIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className={className}
      stroke="currentColor"
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.947 14.667c3.667 0 6.667-3 6.667-6.667s-3-6.667-6.667-6.667S1.28 4.333 1.28 8s3 6.667 6.667 6.667zM5.28 8h5.334"
      ></path>
    </svg>
  )
}
